<template>
  <div class="wrapBox">
    <div class="con-wrap" v-if="baseStation">
      <el-aside width="300px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">区域列表</div>
          </el-col>
          <!-- <el-col :span="2" :offset="6">
            <div
              @click="addArea"
              v-if="hasPerm('sys:area:save')"
              class="grid-content bg-purple iconfont icon-add"
              style="cursor: pointer"
            ></div>
          </el-col> -->
        </el-row>
        <div>
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="areaTreeData"
                node-key="id"
                @node-click="clickArea"
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                  <!-- <span style="display: none">
                    <span
                      @click="editArea(data)"
                      v-if="hasPerm('sys:area:update')"
                      class="iconfont icon-edit"
                    ></span>
                    <span
                      @click="removeArea(data)"
                      v-if="hasPerm('sys:area:delete')"
                      class="iconfont icon-delete"
                    ></span>
                  </span> -->
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </el-aside>
      <el-container style="flex-direction: column">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">区域基站列表</div>
          </el-col>
        </el-row>
        <div class="con-box">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            class="input-form-inline"
            @submit.native.prevent
          >
            <div>
              <el-form-item class="r-20" prop="name">
                <el-input
                  v-model="queryForm.name"
                  @keyup.enter.native="query"
                  placeholder="站址名称"
                ></el-input>
              </el-form-item>
              <el-form-item class="r-20" prop="code">
                <el-input
                  v-model="queryForm.code"
                  @keyup.enter.native="query"
                  placeholder="站址编码"
                ></el-input>
              </el-form-item>
              <el-button
                v-if="hasPerm('base:station:list')"
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button v-if="hasPerm('base:station:list')" @click="reset"
                >取消</el-button
              >
            </div>

            <div style="margin-bottom: 20px">
              <el-button
                v-if="hasPerm('base:station:save')"
                type="primary"
                @click="addStation"
                >新增</el-button
              >
              <el-button
                size="medium"
                v-if="hasPerm('base:station:delete')"
                type="danger"
                @click="delStation"
                >删除</el-button
              >
              <el-button
                v-if="hasPerm('base:station:template')"
                type="primary"
                class="btn-width"
                @click="TemplateDownload"
                >模板下载</el-button
              >
              <el-button
                v-if="hasPerm('base:station:import')"
                type="primary"
                class="btn-width"
                @click="clickImport"
                >批量导入</el-button
              >
            </div>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            stripe
            height="560px"
            @row-click="handleClickTableRow"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="24"
              align="center"
              style="padding: 0"
            ></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="55"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="站址名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="code"
              label="站址编码"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="longitude" label="经度"></el-table-column>
            <el-table-column prop="latitude" label="纬度"></el-table-column>
            <el-table-column
              prop="dcLoadCurrent"
              label="直流负载电流（A）"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="areaName"
              label="归属区域"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  v-if="hasPerm('base:station:update')"
                  @click.stop="editStation(scope.row)"
                  >修改</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  v-if="hasPerm('base:station:info')"
                  @click.stop="stationInfo(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="text"
                  v-if="hasPerm('base:station:addr:traces')"
                  @click.stop="checkPath(scope.row)"
                  >查看路径</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-container>
      <!-- 区域弹框 -->
      <!-- <el-dialog
        :title="areaTitle"
        :visible.sync="areaVisible"
        class="mini-dialog"
      >
        <el-form
          :rules="areaRules"
          ref="areaForm"
          :model="areaForm"
          size="mini"
          :inline="true"
        >
          <el-form-item v-if="editTag == 0" label="上层区域">
            <el-input v-model="areaForm.pName" placeholder disabled></el-input>
          </el-form-item>
          <el-form-item prop="name" label="区域名称">
            <el-input
              v-model="areaForm.name"
              placeholder="请输入区域名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="btn" @click="areaVisible = false">取 消</el-button>
          <el-button type="primary" @click="areaSubmit">确 定</el-button>
        </span>
      </el-dialog> -->
      <!--新增基站-->
      <el-dialog
        :title="editStationTitle"
        :visible.sync="editStationVisible"
        class="station-dialog"
      >
        <el-form
          :rules="stationRules"
          ref="stationForm"
          :model="stationForm"
          size="mini"
          :inline="true"
        >
          <el-form-item prop="name" label="站址名称">
            <el-input
              v-model="stationForm.name"
              placeholder="请输入站址名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code" label="站址编码">
            <el-input
              v-model="stationForm.code"
              placeholder="请输入站址编码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="type" label="站址类型">
            <el-select v-model="stationForm.type" placeholder="请选择站址类型">
              <el-option
                v-for="item in baseTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="gpsType" label="GPS类型">
            <el-select
              v-model="stationForm.gpsType"
              placeholder="请选择GPS类型"
            >
              <el-option
                v-for="item in gpsTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="longitude" label="经度">
            <el-input
              v-model="stationForm.longitude"
              placeholder="请输入经度"
            ></el-input>
          </el-form-item>
          <el-form-item prop="latitude" label="纬度">
            <el-input
              v-model="stationForm.latitude"
              placeholder="请输入纬度"
            ></el-input>
          </el-form-item>
          <el-form-item prop="dcLoadCurrent" label="直流负载电流（A）">
            <el-input
              v-model="stationForm.dcLoadCurrent"
              placeholder="请输入直流负载电流"
            ></el-input>
          </el-form-item>
          <el-form-item prop="addr" label="详细地址">
            <el-input
              type="textarea"
              v-model="stationForm.addr"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-form-item prop="remark" label="备注">
            <el-input
              type="textarea"
              v-model="stationForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editStationVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 详情弹窗 -->
      <el-dialog
        title="详情"
        :visible.sync="infoVisible"
        class="mini-dialog info-box"
      >
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">站址编码</el-col>
          <el-col :span="17">{{ $judgeEmpty(stationInfoData.code) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">站址名称</el-col>
          <el-col :span="17">{{ $judgeEmpty(stationInfoData.name) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">基站直流负载（A）</el-col>
          <el-col :span="17">{{
            $judgeEmpty(stationInfoData.dcLoadCurrent)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">经度</el-col>
          <el-col :span="17">{{
            $judgeEmpty(stationInfoData.longitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">纬度</el-col>
          <el-col :span="17">{{
            $judgeEmpty(stationInfoData.latitude)
          }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">详细地址</el-col>
          <el-col :span="17">{{ $judgeEmpty(stationInfoData.addr) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">备注</el-col>
          <el-col :span="17">{{ $judgeEmpty(stationInfoData.remark) }}</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7" class="dialog-label">归属分组</el-col>
          <el-col :span="17">{{
            $judgeEmpty(stationInfoData.areaName)
          }}</el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="infoVisible = false">取 消</el-button>
          <el-button type="primary" @click="infoVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 批量导入 -->
      <el-dialog
        title="基站批量导入"
        :visible.sync="importVisible"
        class="mini-dialog"
      >
        <el-form
          :rules="areaRules"
          ref="importForm"
          :model="importForm"
          size="mini"
          :inline="true"
        >
          <el-form-item class="upload-box" label="文件名">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :multiple="false"
              :limit="1"
              accept=".xls, .xlsx"
              :data="myData()"
              :file-list="fileList"
              :on-change="addFile"
              :action="uploadUrl()"
              :http-request="uploadSectionFile"
              :auto-upload="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="btn" @click="importVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="importCommit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else class="base">
      <base-station-path :code="code" @goback="goback"></base-station-path>
    </div>
  </div>
</template>

<script>
import BaseStationPath from "@/views/BaseStationManage/AreaBaseStation/BaseStationPath";
export default {
  name: "AreaBaseStation",
  components: {
    BaseStationPath,
  },
  data() {
    return {
      baseStation: true,
      baseTypeList: [],
      gpsTypeList: [
        {
          label: "84",
          value: 1,
        },
        {
          label: "高德",
          value: 2,
        },
        {
          label: "百度",
          value: 3,
        },
      ],
      editTag: "0",
      areaTreeData: [],
      areaForm: {
        name: "",
        pName: "",
      },
      areaRules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入区域名称",
          },
        ],
      },
      pAreaId: "",
      queryForm: {
        name: "",
        code: "",
      },
      editStationTitle: "",
      editStationVisible: false,
      //新增基站
      stationForm: {
        name: "",
        code: "",
        longitude: "",
        latitude: "",
        dcLoadCurrent: "",
        addr: "",
        remark: "",
        areaId: "",
        stationId: "",
      },
      stationId: "",
      stationRules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入名称",
          },
        ],
        code: [
          {
            required: true,
            trigger: "change",
            message: "请输入站址编码",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择站址类型",
          },
        ],
        gpsType: [
          {
            required: true,
            trigger: "change",
            message: "请选择GPS类型",
          },
        ],
        longitude: [
          {
            required: true,
            trigger: "change",
            message: "请输入经度",
          },
          {
            required: true,
            pattern: this.$formRules.longitude,
            message: this.$formRules.longitudeMsg,
            trigger: "change",
          },
        ],
        latitude: [
          {
            required: true,
            trigger: "change",
            message: "请输入纬度",
          },
          {
            required: true,
            pattern: this.$formRules.latitude,
            message: this.$formRules.latitudeMsg,
            trigger: "change",
          },
        ],
        dcLoadCurrent: [
          {
            required: true,
            trigger: "change",
            message: "请输入直流负载电流",
          },
        ],
        addr: [
          {
            required: true,
            trigger: "change",
            message: "请输入详细地址",
          },
        ],
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      stationInfoData: [],
      infoVisible: false,
      importVisible: false,
      fileList: [],
      fileSizeIsSatisfy: false,
      importForm: {},
      extension: "",
      code: null,
    };
  },
  created() {
    this.getAreaList();
    this.getBaseType();
  },
  watch: {
    areaTreeData(val) {
      if (val) {
        this.$nextTick(() => {
          document.querySelector(".el-tree-node__content").click();
        });
      }
    },
  },
  methods: {
    // 查询站址类型
    async getBaseType() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dict/stationType");
      if (res.code == 1) {
        _this.baseTypeList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查看路径
    checkPath(data) {
      this.baseStation = false;
      this.code = data.code;
      // this.$router.push({
      //       name: 'BaseStationPath',
      //       params: {
      //         code: data.code,
      //       }
      //   })
    },
    goback() {
      this.baseStation = true;
    },
    async getAreaList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        _this.areaTreeData = res.data;
        _this.pAreaId = res.data[0].id;
        _this.stationForm.areaId = res.data[0].id;
        _this.areaForm.pName = res.data[0].label;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clickArea(areaDatas) {
      //let areaId = areaDatas.id
      this.pAreaId = areaDatas.id;
      this.stationForm.areaId = areaDatas.id;
      this.areaForm.pName = areaDatas.label;
      //表格数据调取
      this.getStationList();
    },
    query() {
      this.getStationList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getStationList();
    },
    //获取基站列表
    async getStationList() {
      let _this = this;
      let obj = {};
      obj.name = _this.queryForm.name;
      obj.code = _this.queryForm.code;
      obj.areaId = _this.pAreaId;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/base/station/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    addStation() {
      this.editTag = "0";
      //清空表单数据
      this.$resetForm(this, "stationForm");
      this.editStationTitle = "新增基站";
      this.editStationVisible = true;
    },
    editStation(rowData) {
      this.editTag = "1";
      //清空表单数据
      this.$resetForm(this, "stationForm");
      this.editStationTitle = "修改基站";
      this.editStationVisible = true;
      this.stationId = rowData.id;
      this.getStationInfo(rowData.id);
    },
    async getStationInfo(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/info/" + id
      );
      if (res.code == 1) {
        _this.stationForm = res.data;
        _this.stationInfoData = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    saveOrUpdate() {
      let _this = this;
      let data = [];
      _this.$refs.stationForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post(
              "/api/base/station",
              _this.stationForm
            );
          } else {
            _this.stationForm.stationId = _this.stationId;
            data = await _this.$axios.patch(
              "/api/base/station",
              _this.stationForm
            );
          }
          let res = data.data;
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功");
            //刷新表格
            _this.getStationList();
            _this.editStationVisible = false;
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    delStation() {
      let _this = this;
      //多选删除
      let stationIds = _this.$getIds(_this.tableVal);
      if (!stationIds) {
        return;
      }
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete("/api/base/station", {
            data: JSON.stringify(stationIds),
          });
          if (res.code == 1) {
            _this.$message.success("操作成功");
            let totalPage = Math.ceil((_this.total - 1) / 10);
            let currentPage =
              _this.currentPage > totalPage ? totalPage : _this.currentPage;
            _this.currentPage = currentPage < 1 ? 1 : currentPage;
            _this.getStationList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    stationInfo(rowData) {
      this.infoVisible = true;
      this.getStationInfo(rowData.id);
    },
    TemplateDownload() {
      this.$confirm("确定下载该模板吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = "/api/base/station/template";
      });
    },
    // 批量导入-start-
    clickImport() {
      this.fileList = [];
      this.importVisible = true;
    },
    myData() {
      return {
        areaId: this.pAreaId,
      };
    },
    addFile(file, fileList) {
      this.fileList = fileList;
      //限制上传文件为5M
      this.fileSizeIsSatisfy = file.size < 5 * 1024 * 1024 ? true : false;
      this.extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(file.type);
    },
    uploadUrl() {
      return "/api/base/station/import";
    },
    async uploadSectionFile(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("areaId", _this.pAreaId);
      let { data: res } = await _this.$axios.post(
        "/api/base/station/import",
        form
      );
      if (res.code == 1) {
        _this.$message.success("导入成功");
        _this.getStationList();
        _this.importVisible = false;
        //导入成功后清空upload
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
      } else {
        _this.$refs.upload.clearFiles();
        _this.fileList = [];
        _this.$message.warning(res.msg);
      }
    },
    async importCommit() {
      // let _this = this;
      if (this.fileList.length <= 0) {
        this.$message.warning("请至少上传一个文件！");
        return;
      }
      if (this.extension !== "xlsx" && this.extension !== "xls") {
        this.$message.warning("上传失败！请上传excel表格文件！");
        this.$refs.upload.clearFiles();
        this.fileList = [];
        return;
      }
      if (!this.fileSizeIsSatisfy) {
        this.$message.warning("上传失败！文件大小超过5M！");
        this.$refs.upload.clearFiles();
        this.fileList = [];
        return;
      }
      this.$refs.upload.submit();
    },
    // 批量导入-end-
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    handleClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getStationList();
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  display: flex;
  flex-direction: row;
  height: calc(100% - 20px);
}
.con-wrap .el-container {
  background-color: #fff;
}
.is-show:hover :nth-child(2) {
  display: inline-block !important;
}
.con-box {
  padding: 0 20px;
}
.btn-width {
  width: 108px;
}
.station-dialog /deep/ .el-dialog {
  width: 620px;
}
.station-dialog /deep/ .el-form-item__label {
  width: 160px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.station-dialog /deep/ .el-form-item__content {
  width: 380px;
  height: auto;
}
.upload-box /deep/ .el-form-item__label {
  padding-left: 11px;
  position: relative;
}
.upload-box /deep/ .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  position: absolute;
  left: 0px;
  top: 1px;
}
// 详情弹窗
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.info-box /deep/ .el-dialog__body {
  padding-left: 40px;
}
.info-box /deep/ .el-dialog__footer {
  padding-top: 10px;
}
.dialog-label {
  padding-left: 20px;
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
.wrapBox {
  width: 100%;
  height: calc(100% - 20px);
}
.base {
  height: 100%;
}
</style>
